import { Form } from '@ant-design/compatible'
import '@ant-design/compatible/assets/index.css'
import { RouterView } from '@merchant-backend/common-components'
import 'antd4/lib/grid/style/index.css'
import { toJS } from 'mobx'
import { inject, observer } from 'mobx-react'
import React, { Component } from 'react'
import CaseDetail from '../../common/CaseDetail'
import { formItemLayout } from '../../constants'

const FormItem = Form.Item

@inject('store')
@observer
export class DetailInfo extends Component {
  render() {
    const { store } = this.props
    const { form_init, caseImageTag } = store
    const form_default = toJS(form_init)
    const case_content = form_default.case_content

    return (
      <RouterView
        title="案例详细信息"
        bodyStyle={{ padding: '24px 24px 20px 24px' }}
        titleStyle={{ height: 48, padding: '0 24px' }}
        viewStyle={{ margin: '0 20px 4px 20px' }}
      >
        <FormItem className="wrap" {...formItemLayout}>
          <CaseDetail caseContent={case_content} caseImageTag={caseImageTag} />
        </FormItem>
      </RouterView>
    )
  }
}

export default DetailInfo
